import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SortDirections } from '../sortable-section/models/sortable-section.model';

@Component({
  selector: 'app-sortable-section-carets',
  templateUrl: './sortable-section-carets.component.html',
  styleUrls: ['./sortable-section-carets.component.scss'],
})
export class SortableSectionCaretsComponent {
  @Input() displayText: string;
  @Input() headerName: string;
  @Input() selectedHeader: string;
  @Input() sortDirection: string;

  @Output() sortClickEmitter: EventEmitter<string> = new EventEmitter();
  SortDirections = SortDirections;

  constructor() {}

  handleUpdateSortEvent() {
    this.sortClickEmitter.emit(this.headerName);
  }
}
